import React, { Component } from "react";
import { Icon, Spin } from "antd";
import Loader from "app/components/ui/loader";
const loadIcon = <Icon type='loading' />;

const AsyncImport = importComponent => {
  return class extends Component {
    state = {
      component: null
    };
    componentDidMount() {
      importComponent().then(cmp => {
        this.setState({ component: cmp.default });
      });
    }

    render() {
      const C = this.state.component;
      return C ? <C {...this.props} /> : <Loader />;
    }
  };
};

export default AsyncImport;
